import * as React from 'react';
import 'react-dates/initialize';
import { Moment } from 'moment';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import { FieldProps, ErrorMessage } from 'formik';

import { Box } from '../';
import { Label, Span } from '../../typography';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import * as moment from 'moment';
import tag from 'blacklist-tag';
import { theme } from '../../theme';

type State = {
  focused: boolean;
  date: Moment;
};

type Props = StyledSystemProps &
  FieldProps & {
    name: string;
    label?: string;
    color?: string;
    date?: Moment;
    bg?: string;
    disabled?: boolean;
  };

const DatePickerWrapper = styled.div`
  width: 100%;
  .DateInput {
    display: flex;
    height: 40px;
    width: 100%;
  }
  .DateInput_input {
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    border: 1px solid rgba(50, 50, 93, 0.2);
    color: ${themeGet('colors.coal', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
    font-family: ${themeGet('fontFamily')};
    font-style: normal;
    background-color: ${themeGet('colors.paleGrey', '#f0f1f3')};
    &:disabled {
      opacity: 0.5;
    }
  }
  .SingleDatePicker {
    display: flex;
  }
  .SingleDatePicker_picker {
    z-index: ${theme.zIndex[6]};
  }
  .SingleDatePicker > div,
  .SingleDatePicker > div > .SingleDatePickerInput {
    width: 100%;
  }
  .SingleDatePickerInput__withBorder {
    border: none;
    height: 40px;
  }
  .CalendarMonth_caption {
    padding-top: 16px;
  }
`;

const StyledSelect = styled.select`
  height: 34px;
  margin-right: 0;
  background-color: #fff;
  border: 1px solid #e4e7e7;
  color: ${themeGet('colors.coal', '#222429')};
  font-size: ${themeGet('fontSize[1]', '16px')};
`;

class StyledDatePicker extends React.Component<Props, State> {
  static defaultProps = {
    mb: 4,
    flex: 1,
    minWidth: '150px',
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      date: (props.field && props.field.value) || null,
      focused: false,
    } as State;
  }

  renderOptions() {
    let arr = [];
    for (let i = -100; i <= 0; i++) {
      arr.push(
        <option key={moment().year() + i} value={moment().year() + i}>
          {moment().year() + i}
        </option>
      );
    }
    return arr;
  }

  render() {
    const { form, name, label, disabled, field } = this.props;
    return (
      <Box {...this.props}>
        <Label htmlFor={name}>{label}</Label>
        <DatePickerWrapper>
          {/*@ts-ignore*/}
          <SingleDatePicker
            displayFormat={'DD/MM/YYYY'}
            placeholder="Select date"
            numberOfMonths={1}
            onFocusChange={({ focused }: { focused: boolean }) => this.setState({ focused })}
            // @ts-ignore
            onDateChange={(date: Moment) =>
              this.setState({ date }, () => {
                form.setFieldValue(name, date);
              })
            }
            // @ts-ignore
            date={this.state.date}
            focused={this.state.focused}
            id={field.name}
            disabled={disabled}
            isOutsideRange={() => false}
            // TODO: Possibly implement react-select for DOB selection
            renderMonthElement={({ month, onMonthSelect, onYearSelect }) => {
              return (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div>
                    <StyledSelect
                      name={field.name}
                      value={month.month()}
                      onChange={(e) => {
                        onMonthSelect(month, e.target.value);
                      }}
                    >
                      {moment.months().map((lbl, value) => (
                        <option key={value} value={value}>
                          {lbl}
                        </option>
                      ))}
                    </StyledSelect>
                  </div>
                  <div>
                    <StyledSelect
                      name={field.name}
                      value={month.year()}
                      onChange={(e) => {
                        onYearSelect(month, e.target.value);
                      }}
                    >
                      {this.renderOptions()}
                    </StyledSelect>
                  </div>
                </div>
              );
            }}
          />
        </DatePickerWrapper>
        <ErrorMessage name={name}>
          {(msg) => {
            return (
              <Span mt={2} color="error" textAlign="right">
                {msg}
              </Span>
            );
          }}
        </ErrorMessage>
      </Box>
    );
  }
}

export const CleanDatePicker = tag(StyledDatePicker, [
  'width',
  'display',
  'alignItems',
  'flexDirection',
  'justifyContent',
]);

export default CleanDatePicker;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledDatePicker.tsx